// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2da76414","455":"d2fa7abf","977":"e7dfc391"}[chunkId] + ".chunk.js";
};